import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'
import AuthApi from '../../api/auth/AuthApi'
import { PasswordDto, TokenDto } from '../../api/auth/types'
import { HttpError } from '../../types/common'
import { showErrorToast } from '../../utils/errors'
import { useNavigate } from 'react-router-dom'

const authApi = AuthApi.getInstance()

export function useActivateAccount() {
  const texts = useTranslation().t
  const navigate = useNavigate()

  const mutation = useMutation((data: PasswordDto & TokenDto) => authApi.activateUser(data), {
    onSuccess: () => {
      toast.success(texts('successes:activate_account'))
      navigate('/')
    },
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}